import React from 'react';
import useStyles from './styles';
import Paper from '@material-ui/core/Paper';

export default props => {
  const {
    input,
    previews,
    submitButton,
    dropzoneProps,
    files,
    extra: { maxFiles },
  } = props;

  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      {files.length === maxFiles ? null : <div {...dropzoneProps}>{input}</div>}
      <div className={classes.previews}>{previews}</div>
      <div className={classes.submitButton}>{files.length > 0 ? submitButton : null}</div>
    </Paper>
  );
};
